import Proptypes from "prop-types"
import { IconButton } from "@mui/material"
import { Add } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"

export default function SaveExperimentButton({ saveDisabled, toggleSaveExperiment, tooltipOverride }) {
  return <Tooltip title={tooltipOverride || "Save experiment"} className="component_save-experiment">
    {/* The extra span is required for the tooltip to show up on a disabled button */}
    <span>
      <IconButton
        disabled={saveDisabled}
        onClick={toggleSaveExperiment}
        className="save-experiment"
        size="large"
      >
        <Add />
      </IconButton>
    </span>
  </Tooltip>
}

SaveExperimentButton.propTypes = {
  toggleSaveExperiment: Proptypes.func.isRequired,
  saveDisabled: Proptypes.bool,
  tooltipOverride: Proptypes.string,
}
